﻿/*
 * Purpose: Render T&Cs text display and acceptance button.
 * Boundary: Presentational only; no local state, logic, or effects.
 * Invariants:
 * - Controlled via checked/onChange props; parent manages state.
 * - Button appears below T&Cs text display.
 * - ASCII only; comments and strings are plain ASCII.
 */

// Component TcsTextDisplay:
// Stateless display of T&Cs text with consistent styling
export function TcsTextDisplay({ text }) {
    // Rendering - text display in bordered container
    return (
        <div className="p-3 md:p-4 border border-neutral-800 rounded-lg bg-neutral-900">
            <p className="text-sm text-neutral-300 leading-relaxed">
                {text}
            </p>
        </div>
    );
}

// Component AcceptTermsButton (Default - Bracket Style):
// Slim button with [✓] checkbox prefix - minimalist text-based indicator
export function AcceptTermsButton({ checked, onChange, disabled }) {
    // Rendering - slim button with bracket-style checkbox indicator
    return (
        <button
            type="button"
            onClick={() => onChange(!checked)}
            disabled={disabled}
            className="w-full px-3 py-1 md:px-4 md:py-1 rounded-lg bg-emerald-600 hover:bg-emerald-500 active:bg-emerald-700 transition text-white text-sm md:text-base font-medium disabled:opacity-60 touch-manipulation flex items-center justify-center gap-2"
            aria-pressed={checked}
            role="switch"
        >
            <span className="flex items-center gap-1 flex-shrink-0">
                <span className="text-white">[</span>
                <span className="w-3 text-center">
                    {checked ? '✓' : ' '}
                </span>
                <span className="text-white">]</span>
            </span>
            <span>Accept Terms & Conditions</span>
        </button>
    );
}

// Component AcceptTermsButtonStandard:
// Alternative with clean SVG checkbox indicator - professional look
export function AcceptTermsButtonStandard({ checked, onChange, disabled }) {
    // Rendering - slim button with checkbox indicator matching OTP button height
    return (
        <button
            type="button"
            onClick={() => onChange(!checked)}
            disabled={disabled}
            className="w-full px-3 py-1 md:px-4 md:py-1 rounded-lg bg-emerald-600 hover:bg-emerald-500 active:bg-emerald-700 transition text-white text-sm md:text-base font-medium disabled:opacity-60 touch-manipulation flex items-center justify-center gap-2"
            aria-pressed={checked}
            role="switch"
        >
            {/* Checkbox indicator */}
            <span className="w-4 h-4 rounded border-2 border-white flex items-center justify-center flex-shrink-0">
                {checked && (
                    <svg
                        className="w-3 h-3"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10 3L4.5 8.5L2 6"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
            </span>
            <span>Accept Terms & Conditions</span>
        </button>
    );
}